import React from "react";

export const ContentHeadline = ({ title }) => {
  return title && <h2 className="text-xl text-gray-500 mb-6 font-thin">{title}</h2>;
};
